import { getMetadata } from "../metadata";
import { RESULT_STATUS } from "./result";
import { isModuleRegistered } from "SharedStores/util";
import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
import { DATA_FIELD_TYPE } from "Types/dataFieldTypes";

export class HelperEvaluator {
    constructor(formulaEvaluator, { rootState, rootGetters }, $serviceControllers) {
        this.formulaEvaluator = formulaEvaluator;
        this.state = rootState;
        this.getters = rootGetters;
        this.$serviceControllers = $serviceControllers;
    }
    evalNum(exp) {
        return this.formulaEvaluator.evalNum(exp);
    }
    evalBool(exp) {
        return this.formulaEvaluator.evalBool(exp);
    }
    evalString(exp) {
        return this.formulaEvaluator.evalString(exp);
    }
    evalDate(exp) {
        return this.formulaEvaluator.evalDate(exp);
    }
    getMetadata(exp) {
        return getMetadata(exp);
    }
    _negateResult(result) {
        if (result.Status === RESULT_STATUS.Error) {
            return result;
        }
        const value = !result.Value;
        return { Value: value };
    }
    _convertValueToString(exp, value) {
        if (!isModuleRegistered(PROGRAM_NAMESPACE, this.state)) {
            throw Error("program store not registered");
        }

        // Find out how to process value based on type of data field
        // being referenced
        const dfd = this.getters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](exp.PublicDataFieldDefinitionId);
        switch (dfd.TypeId) {
            case DATA_FIELD_TYPE.String:
            case DATA_FIELD_TYPE.Integer:
            case DATA_FIELD_TYPE.Decimal:
            case DATA_FIELD_TYPE.DateTime:
            case DATA_FIELD_TYPE.Timestamp:
                break;
            case DATA_FIELD_TYPE.Boolean: {
                // For parity with server, capitalize "True" or "False" since
                // those are the results of bool.ToString
                if (value === true || value === "true" || value === "True") {
                    value = "True";
                } else {
                    value = "False";
                }
                break;
            }
            case DATA_FIELD_TYPE.Choice: {
                if (!value) {
                    break;
                }

                const listItem = this.getters[PROGRAM_TYPES.getters.listItemFromId](value);
                if (listItem) {
                    value = listItem.Value;
                }
                break;
            }
            default:
                throw `Missing code to handle value of type ${dfd.TypeId}`;
        }
        return value;
    }
}
